import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconInfo20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconInfo20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M11.5 3.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M7.25 8.25A.75.75 0 0 1 8 7.5h2.75a.75.75 0 0 1 .75.75v8.25h1.75a.75.75 0 0 1 0 1.5h-5a.75.75 0 0 1 0-1.5H10V9H8a.75.75 0 0 1-.75-.75"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconInfo20);
